(function () {

    var viewService;

var InviteToInterviewForm = function (scope, nunjucksEngine, hUser, InterviewViewService, InterviewDataService) {

    var self = this;
    var _protected = BaseForm.call(self, "invite-to-interview-form", scope);

    //interview slots
    self.data.interviewSlots = [];
    //interview duration
    var interview_duration = 30;
    self.data.interview_duration = null;
    var to_interview_duration = null;
    //errors
    self.data.errors = {};
    var nunjucksEngine = nunjucksEngine;
    var interviewCalendar;
    var deletedSlots = [];
    var defaultLocationId;
    var locationFromServer;

    //allow overlap
    self.data.interview_overlap = true;
    self.startDayOfWeek = 'MON';

    //hold message sent to candidate
    self.data.message = $filter("translate")("Hello")
        + " <first name will be inserted>,\n\n"
        + $filter("translate")("Congratulations") + "!"
        + " <business name> "
        + $filter("translate")("would like to invite you to an interview for the")
        + " <sub category> "
        + $filter("translate")("position. Schedule a time and date for your interview by clicking below")
        + ".\n\n\n<interview link will be inserted>";

    //bind some actions
    $(document)
        .off('click.inviteInterviewDurationOverlay')
        .on('click.inviteInterviewDurationOverlay', '.invite-to-interview-form .overlay', function (event) {
            self.showInterviewDurationMessage();
        });

    /***
     * Load form data
     */
    self.load = function () {

        //rest location change warning
        self.showLocationWarning = false;
        // Remove existing interview slots (start fresh)
        self.data.interviewSlots = [];
        //init some vars
        self.data.errors.interview_duration_change = false;
        self.data.errors.reservedSlots = false;
        self.data.errors.reservedSlot = false;

        self.isInterviewV2ServiceEnabled = hUser.isInterviewV2ServiceEnabled();
        self.isAQAAFServiceEnabled = hUser.isAQAAFServiceEnabled();
        self.weekStartDate = getWeekStart(moment().startOf('day'), self.startDayOfWeek);
        self.weeklyRange = {
            from: self.weekStartDate.clone(),
            to: self.weekStartDate.clone().add(6, 'd')
        };

        InterviewDataService.parseData(self.weekStartDate, {});
        viewService = InterviewViewService({});
        viewService.init(self.weekStartDate);

        var selectedCandidate = self.data.selected_candidates[0];
        var interview_set_id;
        if (
            selectedCandidate &&
            selectedCandidate['interview_status'] &&
            selectedCandidate['interview_status']['interview_set'] &&
            selectedCandidate['interview_status']['interview_set']['id'] &&
            ["WITHDRAWN", "DECLINED"].indexOf(selectedCandidate['interview_status']['status']) < 0
        ) {
            interview_set_id = selectedCandidate['interview_status']['interview_set']['id'];
        }

        var interviewSetPromise;
        if (self.isInterviewV2ServiceEnabled || self.isAQAAFServiceEnabled) {
            if (interview_set_id) {
                self.data.interview_set_id = interview_set_id;
                interviewSetPromise = InterviewV2API.getInterviewSetDetails(self.data.brandId.id, self.data.job.id, interview_set_id);
            }
            else {
                interviewSetPromise = InterviewV2API.getJobInterviewSetsInfo(self.data.brandId.id, self.data.job.id);
            }

            BrandAPI.getBrandInterviewers(self.data.brandId.id)
                .then(function (response) {
                    self.interviewersList = [];
                    self.interviewersList = response.users.map(function(emp) {
                        return {
                            id: emp.id,
                            name: emp.first_name + ' ' + emp.last_name
                        };
                    });

                    InterviewDataService.flatData['interviewers'] = response.users;
                    scope.$digest();
                });
        }
        else {
            interviewSetPromise = InterviewAPI.getSlotsEmployer(self.data.job.id, self.data.brandId.id);
        }

        if (self.isInterviewV2ServiceEnabled || self.isAQAAFServiceEnabled) {
            interviewSetPromise
                .then(function (res) {

                    if (interview_set_id) {

                        var interview_set = res.interview_set;
                        self.data.interview_set_id = interview_set.id;
                        self.data.selected_location = interview_set.location;
                        InterviewDataService.parseData(self.weekStartDate, interview_set.slots);
                        self.data.message = interview_set.message.message;
                        self.data.type = interview_set.type;

                        var interview_duration = String((interview_set.duration / 60) || 15);
                        self.data.custom_duration_hours = String(parseInt(parseInt(interview_duration) / 60) * 60);
                        self.data.custom_duration_minutes = String(parseInt(interview_duration) % 60);
                        viewService.stepSize = parseInt(interview_duration);
                        if ([15, 30, 60, 90, 120].indexOf(parseInt(interview_duration)) < 0) {
                            self.data.interview_duration = 'CUSTOM';
                        } else {
                            self.data.interview_duration = interview_duration;
                        }
                        self.data.interview_overlap = interview_set.allow_overlap || false;
                        self.data.interviewers = [];
                        self.data.interviewers = interview_set.interviewers.map(function (emp) {
                            return {
                                id: emp.user.id,
                                name: emp.user.first_name + ' ' + emp.user.last_name
                            };
                        });
                    }
                    else {
                        var defaults = res.defaults;
                        // res.defaults for the NEW FLOW and res.interview_set for the EDIT FLOW
                        var interview_duration = String((defaults.duration / 60) || 15); // /60 if it comes in seconds
                        self.data.custom_duration_hours = String(parseInt(parseInt(interview_duration) / 60) * 60);
                        self.data.custom_duration_minutes = String(parseInt(interview_duration) % 60);
                        viewService.stepSize = parseInt(interview_duration);
                        if ([15, 30, 60, 90, 120].indexOf(parseInt(interview_duration)) < 0) {
                            self.data.interview_duration = 'CUSTOM';
                        } else {
                            self.data.interview_duration = interview_duration;
                        }
                        self.data.interview_overlap = defaults.allow_overlap || false;
                        self.data.interviewers = [];
                        self.data.interviewers = defaults.interviewers.map(function (emp) {
                            return {
                                id: emp.user.id,
                                name: emp.user.first_name + ' ' + emp.user.last_name
                            };
                        });
                    }

                    // We have to put both of these promises inside a queue and initialize the schedule after
                    if (self.data.interviewers.length) {
                        // load interviewers' available and booked slots
                        var availableSlotsPromise = InterviewV2API.getJobInterviewersAvailabilities(
                            self.data.brandId.id,
                            self.data.job.id,
                            _.pluck(self.data.interviewers, 'id'),
                            self.weeklyRange.from,
                            moment(self.weeklyRange.to).add('d', 1),
                            "AVAILABLE"
                        );

                        var bookedSlotsPromise = InterviewV2API.getJobInterviewersAvailabilities(
                            self.data.brandId.id,
                            self.data.job.id,
                            _.pluck(self.data.selected_candidates, 'id'), // this needs to be self.data.interviewers
                            self.weeklyRange.from,
                            moment(self.weeklyRange.to).add('d', 1),
                            "BOOKED"
                        );

                        var availabilityPromises = {available: availableSlotsPromise, booked: bookedSlotsPromise};

                        $q.all(availabilityPromises)
                            .then(function (response) {
                                var availableSlots = response.available.interviewers;
                                var bookedSlots = response.booked.interviewers;

                                InterviewDataService.resetAvailabilities();
                                InterviewDataService.parseAvailabilities(bookedSlots, "BOOKED");
                                InterviewDataService.parseAvailabilities(availableSlots, "AVAILABLE");
                                // viewService.init(self.weekStartDate);
                                viewService.drawAll();

                                scope.$digest();

                            }, function (err) {
                                console.error(err);
                                scope.$digest();
                            });
                    }
                    else {
                        viewService.init(self.weekStartDate);
                        viewService.drawAll();
                    }

                    scope.$digest();
                });
        }
        else {
            interviewSetPromise
                .then(function (result) {
                    console.log("InterviewAPI.getSlotsEmployer", result)
                    InterviewDataService.parseData(self.weekStartDate, result.slots);
                    viewService = InterviewViewService({});
                    viewService.init(self.weekStartDate);
                    viewService.drawAll();

                    //save employer slots
                    self.data.interviewSlots = result.slots;


                    //set selected location & overide if exist
                    if (result.location) {
                        self.setSelectedLocation(result.location.id);
                        locationFromServer = result.location;
                    } else if (defaultLocationId) {
                        self.setSelectedLocation(defaultLocationId);
                    }

                    //set some values
                    self.data.interview_overlap = result.allow_overlap;

                    //if there is no interview slots then don't update deafult interview duration
                    if (self.data.interviewSlots && self.data.interviewSlots.length > 0) {
                        //if it's there then update it otherwise keep deafult for drwaing the fucking calendar
                        self.data.interview_duration = result.duration;
                        if (self.data.interview_duration) {
                            interview_duration = self.data.interview_duration;
                        }
                    }

                    //calculate slot parts
                    var slotParts = 60 / interview_duration;

                    //sync scope
                    syncScope();

                    //set start date to job published date
                    var startDate = moment(new Date());
                    var timezone = startDate.zone();
                    startDate.set('minute', 0);
                    startDate.set('second', 0);
                    startDate.set('millisecond', 0);
                    startDate.day(0);
                    startDate.zone(timezone);
                    startDate.set('hour', InterviewCalendar.hourStart);

                    //min navigation date is set to job publish date
                    var minNavDate = moment(self.data.job.publish_date);
                    //max nav date
                    var maxNavDate = startDate.clone();
                    maxNavDate = maxNavDate.add(InterviewCalendar.interviewWeekRange, 'weeks');

                    renderCalendar(startDate, slotParts, self.data.interviewSlots, minNavDate, maxNavDate);
                });
        }
    };

    scope.onInterviewersChanged = function ($event) {
        var interviewers = $event.val;
        if (interviewers.length > 0) {
            // load interviewers' available and booked slots
            var availableSlotsPromise = InterviewV2API.getJobInterviewersAvailabilities(
                self.data.brandId.id,
                self.data.job.id,
                interviewers,
                self.weeklyRange.from,
                moment(self.weeklyRange.to).add('d', 1),
                "AVAILABLE"
            );

            var bookedSlotsPromise = InterviewV2API.getJobInterviewersAvailabilities(
                self.data.brandId.id,
                self.data.job.id,
                interviewers,
                self.weeklyRange.from,
                moment(self.weeklyRange.to).add('d', 1),
                "BOOKED"
            );

            var availabilityPromises = {available: availableSlotsPromise, booked: bookedSlotsPromise};

            $q.all(availabilityPromises)
                .then(function (response) {
                    var availableSlots = response.available.interviewers;
                    var bookedSlots = response.booked.interviewers;

                    InterviewDataService.resetAvailabilities();
                    InterviewDataService.parseAvailabilities(bookedSlots, "BOOKED", interviewers.length);
                    InterviewDataService.parseAvailabilities(availableSlots, "AVAILABLE", interviewers.length);
                    // viewService.init(self.weekStartDate);
                    // viewService.drawGridAvailabilities();
                    viewService.drawAll();

                    scope.$digest();

                }, function (err) {
                    console.error(err);
                    scope.$digest();
                });
        }
        else {
            InterviewDataService.resetAvailabilities();
            viewService.clearGridAvailabilities();
        }
    };

    self.save = function () {
        var defer = $q.defer();
        var promises = {};

        var submitBtn = $('.invite-to-interview-form').find('#submit-btn');
        submitBtn.button('loading');

        if (self.validator.validate()) {

            //validate time slots
            if (!validAvailability()) {
                self.data.errors.timeSlot = true;
                submitBtn.button('reset');
                defer.reject({code: "validation", message: "No Interview Slots"});
            } else {
                //before save
                var formData = {};
                formData.ids = [];
                formData.message = self.data.message;

                _.each(self.data.selected_candidates, function (obj) {
                    formData.ids.push(obj.id);
                });

                if (self.data.job.alias_position && $.trim(self.data.job.alias_position) != '') {
                    formData.message = formData.message.replace('<sub category>', self.data.job.alias_position);
                }
                else {
                    formData.message = formData.message.replace('<sub category>', self.data.job.Position.name);
                }

                formData.brand_id = self.data.brandId.id;

                formData.message = formData.message.replace('<business name>', self.data.job.Brand.name);
                formData.message = formData.message.replace('<interview link will be inserted>', '');

                var slotsSent = [];
                //loop all slots and convert them to UTC
                for (var i in InterviewDataService.flatData.slots) {
                    slotsSent.push({
                        start_time: moment.utc(InterviewDataService.flatData.slots[i].start_time),
                        end_time: moment.utc(InterviewDataService.flatData.slots[i].end_time)
                    });
                }

                var payload = {
                    allow_overlap: !!self.data.interview_overlap,
                    duration: (parseInt(interview_duration) * 60),
                    title: "",
                    interviewers: _.map(self.data.interviewers, function (value) {
                        return { user_id: value.id };
                    }),
                    location: self.data.selected_location,
                    slots: slotsSent,
                    applications: [{
                        application_id: self.data.selected_candidates[0]['application_id'],
                        user_id: self.data.selected_candidates[0]['id']
                    }],
                    message: {
                        message: self.data.message
                    }
                };

                if (self.data.interview_set_id) {
                    InterviewV2API.updateBrandInterviewSet(self.data.brandId.id, self.data.interview_set_id, payload)
                        .then(function (response) {

                            submitBtn.button('reset');

                            defer.resolve({
                                appIds: [
                                    payload.applications[0].application_id
                                ],
                                interviews_statuses: [{
                                    status: InterviewV2API.INTERVIEW_STATUSES.SENT,
                                    appId: payload.applications[0].application_id
                                }]
                            });
                        }, function (error) {
                            console.error(error);
                        });
                }
                else {
                    payload['type'] = "INVITE";
                    payload['job_id'] = self.data.job.id;

                    InterviewV2API.saveBrandInterviewSet(self.data.brandId.id, payload)
                        .then(function (response) {

                            submitBtn.button('reset');

                            defer.resolve({
                                appIds: [
                                    payload.applications[0].application_id
                                ],
                                interviews_statuses: [{
                                    status: InterviewV2API.INTERVIEW_STATUSES.SENT,
                                    appId: payload.applications[0].application_id
                                }]
                            });
                        }, function (error) {
                            console.error(error);
                        });
                }

                // InterviewAPI.setSlots(self.data.job.id,
                //     self.data.brandId.id,
                //     self.data.selected_location.id,
                //     slotsSent,
                //     parseInt(interview_duration),
                //     self.data.interview_overlap)
                //     .then(function (slotsResponse) {
                //
                //         // Now schedule the interview for selected users
                //         InterviewAPI.sendInterview(self.data.job.id,
                //             formData.ids,
                //             formData.message,
                //             self.data.selected_location.id,
                //             formData.brand_id
                //         )
                //             .then(function (res) {
                //
                //                 res.deleted_applications = slotsResponse.deleted_applications;
                //
                //                 res.appIds = [];
                //
                //                 for (var i in res) {
                //                     if (res[i] && res[i].job_application_id) {
                //                         res.appIds.push(res[i].job_application_id);
                //                     }
                //                 }
                //
                //                 submitBtn.button('reset');
                //                 defer.resolve(res);
                //
                //             }, function (err) {
                //                 submitBtn.button('reset');
                //                 defer.reject(err);
                //             })
                //
                //     }, function (err) {
                //         submitBtn.button('reset');
                //         defer.reject(err);
                //     });
            }
            //end before save
        }
        else {
            submitBtn.button('reset');
            defer.reject({code: "validation", message: "Form didn't validate"});
        }

        return defer.promise;
    };

    self.onWeekSelected = function (weekRange) {

        if (viewService && weekRange) {
            self.weeklyRange = weekRange;
            viewService.destroy();
            viewService.stepSize = parseInt(interview_duration);
            viewService.init(getWeekStart(weekRange.selected_date || moment().startOf('day'), self.startDayOfWeek || 'MON'));
            viewService.drawAll();
        }
    };

    self.clearSlots = function () {
        InterviewDataService.clearSlots();
        viewService.clearSlots();
        viewService.drawAll();
    };

    var hasInterviews;

    self.setHasInterviews = function (value) {
        hasInterviews = value;
    };

    self.resetComingSlots = function () {

        self.data.errors.interview_duration_change = false;
        self.reservedSlots = [];

        if (interviewCalendar) {
            var indicesToDelete = [];
            var now = moment();

            for (var i = self.data.interviewSlots.length - 1; i >= 0; i--) {
                var slot = self.data.interviewSlots[i];

                if (slot.reserved_by) {
                    self.reservedSlots = self.reservedSlots.concat(slot.reserved_by);
                }
                if (now.isBefore(slot.start_time)) {
                    indicesToDelete.push(i);
                }
            }

            for (var i in indicesToDelete) {
                ar_delete(self.data.interviewSlots, indicesToDelete[i]);
            }

            interviewCalendar.renderCalendar();
        }
        if (to_interview_duration) {
            self.data.interview_duration = to_interview_duration;
        }

        self.data.errors.reservedSlots = self.reservedSlots.length > 1;
        self.data.errors.reservedSlot = self.reservedSlots.length === 1;
    };

    /***
     *
     * validate availability
     *
     * check if any slot is in future and (it's not reserved  || (reserved && overlap is on))
     */
    var validAvailability = function () {

        var isEmpty = true;
        for (var i in viewService.viewData.schedule.columns) {
            var column = viewService.viewData.schedule.columns[i];
            if (column.slots.length) {
                isEmpty = false;
                break;
            }
        }

        // return true for valid availability
        return !isEmpty;
    };

    /**
     * validate if the user can change interview duration or not
     */
    var canChangeDuration = function (slots) {
        var todayDate = new Date();

        for (var i in slots) {

            //if the start time of any slot is greater than now - you can't change duration
            if (slots[i].start_time.getTime() > todayDate.getTime()) {
                return false;
            }

        }

        return true;
    };

    self.validator.validateCustom = function (field, optionsField, rule, showError) {

        var name = field.attr("name");
        var value = self.validator.getFieldValue(field);

        switch (rule.name) {
            case "location_change_confirm":
                if (self.data.selected_location && locationFromServer) {
                    if (self.data.selected_location.id != locationFromServer.id && hasInterviews) {
                        self.showLocationWarning = true;
                    }
                    else {
                        self.showLocationWarning = false;
                    }
                }
                else {
                    self.showLocationWarning = false;
                }
                break;

            case "required-if":

                if (self.data.selected_location && self.data.selected_location.id == 'CUSTOM' && !value) {
                    self.validator.validation[name].errors[rule.name] = true;
                    return false;
                }

                break;
        }

        return true;
    };

    var renderCalendar = function (startDate, slotParts, employerSlots, minNavDate, maxNavDate) {
        interviewCalendar = new InterviewCalendar(nunjucksEngine, {
            type: 'schedule',
            elementSelector: '#interview-calendar',
            startDate: startDate,
            minNavDateTime: minNavDate,
            maxNavDateTime: maxNavDate,
            selectionType: 'selectable',
            employerSlots: employerSlots,
            slotParts: slotParts,
            applyCustomScroller: true,
            onSlotChanged: function (slot) {

                //find if it's already there
                var slotIndex = findSlotIndex(slot, self.data.interviewSlots);

                //push it or remove
                if (slotIndex > -1) {
                    var removedSlot = ar_delete(self.data.interviewSlots, slotIndex);
                    if (removedSlot.reserved_by) {
                        deletedSlots.push(removedSlot);
                    }
                } else {

                    //update errors
                    self.data.errors.timeSlot = false;
                    syncScope();

                    var slotData = {};

                    //find if the new slot is in deleted slots
                    var slotIndex = findSlotIndex(slot, deletedSlots);
                    if (slotIndex > -1) {
                        slotData = ar_delete(deletedSlots, slotIndex);
                    } else {
                        //convert to utc before sending to API
                        slotData.start_time = new Date(parseInt(slot.start_time));
                        slotData.end_time = new Date(parseInt(slot.end_time));
                        slotData.id = slot.id;
                    }
                    //push slot to interview slots
                    self.data.interviewSlots.push(slotData);
                }

            }
        });
    };

    /***
     * find slot index in array
     *
     * @param slot
     * @param arr
     */
    var findSlotIndex = function (slot, arr) {

        var slotIndex = -1;
        for (var i in arr) {
            if (arr[i].start_time.getTime() == new Date(slot.start_time).getTime()) {
                slotIndex = i;
                break;
            }
        }

        return slotIndex;
    };

    self.cancelChangeDuration = function () {
        self.data.errors.interview_duration_change = false;
    };

    self.confirmChangeDuration = function () {
        self.resetComingSlots();
        InterviewDataService.clearSlots();
        viewService.clearSlots();
        self.updateInterviewDuration();
    };

    self.updateInterviewDuration = function (isCustom) {

        if (interview_duration != self.data.interview_duration) {
            interview_duration = self.data.interview_duration;
            if (isCustom || self.data.interview_duration == 'CUSTOM') {
                interview_duration = parseInt(self.data.custom_duration_hours) + parseInt(self.data.custom_duration_minutes);
            } else {
                interview_duration = parseInt(self.data.interview_duration);
                self.data.custom_duration_hours = String(parseInt(parseInt(interview_duration) / 60) * 60);
                self.data.custom_duration_minutes = String(parseInt(interview_duration) % 60);
            }

            viewService.clearSlots();
            viewService.stepSize = interview_duration;
            viewService.drawAll();
        }
    };

    /***
     * set Selected Location
     *
     * @param locationId
     */
    self.setDefaultLocation = function (locationId) {
        defaultLocationId = locationId;
    };

    /***
     * set Selected Location
     *
     * @param locationId
     */
    self.setSelectedLocation = function (locationId) {
        if (self.data.locations) {
            self.data.locations.forEach(function (location) {
                if (locationId == location.id) {
                    self.data.selected_location = location;
                }
            });
            syncScope();
        }
        else {
            console.error("No locations for interview", self.data.locations, locationId);
        }
    };

    /***
     * set brand id
     *
     * @param brandId
     */
    self.setBrandId = function (brandId) {
        self.data.brandId = brandId;
        syncScope();
    };

    /***
     * get brandId
     *
     * @returns {*}
     */
    self.getBrandId = function () {

        return self.data.brandId;
    };

    /***
     * set Job
     *
     * @param job
     */
    self.setJob = function (job) {
        self.data.job = job;
        syncScope();
    };

    /****
     * set candidates
     *
     * @param candidates
     */
    self.setCandidates = function (candidates) {
        self.data.candidates = candidates;
        syncScope();
    };

    /***
     *
     * Set selected candidates
     *
     * @param candidates
     */
    self.setSelectedCandidates = function (candidates) {
        //$parse('data.selected_candidates').assign(scope, d);
        self.data.selected_candidates = candidates;
        syncScope();
    };

    /****
     * set locations
     *
     * @param locations
     */
    self.setLocations = function (locations) {
        self.data.locations = locations;
        if (hUser.isInterviewV2ServiceEnabled()) {
            self.data.locations.push({
                formatted_address: "Custom",
                id: "CUSTOM"
            });
        }
        syncScope();
    };

    /****
     * set User
     *
     * @param user
     */
    self.setUser = function (user) {
        self.data.user = user;
        syncScope();
    };

    /****
     *
     * set saved callback
     *
     * @param onSavedCallback
     */
    self.setOnSavedCallback = function (onSavedCallback) {
        self.onSavedCallback = onSavedCallback;
        syncScope();
    };

    /***
     *
     * get selected candidates to schedule interview
     *
     * @returns {*}
     */
    self.getSelectedCandidates = function () {
        return self.data.selected_candidates;
    };

    /***
     * show interview duraction action messgae
     *
     */
    self.showInterviewDurationMessage = function () {
        $('.invite-to-interview-form .interview-duration-action-msg').fadeIn();
        $button = $(".invite-to-interview-form .interview_duration");
        $button
            .stop()
            .animate({'right': '10px'}, 20)
            .animate({'right': '2px'}, 40)
            .animate({'right': '10px'}, 40)
            .animate({'right': '2px'}, 40)
            .animate({'right': '10px'}, 40)
            .animate({'right': '2px'}, 40)
            .animate({'right': '10px'}, 40)
            .animate({'right': '0'}, 20);

        setTimeout(function () {
            $('.invite-to-interview-form .interview-duration-action-msg').fadeOut();
        }, 4000);
    };

    var syncScope = function () {

        //avoid error if the digest is already in progress
        setTimeout(function () {
            scope.$digest();
        }, 1);
    };
};

    angular
        .module('harriApp')
        .service('InviteToInterviewForm', [
            'hUser',
            'InterviewViewService',
            'InterviewDataService',
            function (hUser, InterviewViewService, InterviewDataService) {
                return function (scope, nunjucksEngine) {
                    return new InviteToInterviewForm(scope, nunjucksEngine, hUser, InterviewViewService, InterviewDataService);
                }
            }]);
})();